import { get } from "./get.js";
import { post } from "./post.js";
import { put } from "./put.js";
import { remove } from "./remove.js";

export const requestsTemplates = { get, post, put, remove };
